import axios from '@/_legacy/util/axios';
import { eventBus } from '../eventBus';
import { fetchUser } from '@/ui/auth/auth';
import { StatusCodes } from 'http-status-codes';

function getSubscription() {
  return axios.get(
    'v1/subscriptions',
  )
    .then(({ data }) => data)
    .catch(e => {
      if (e.response.status === StatusCodes.NOT_FOUND) {
        eventBus.$emit('subscription-not-found');
      }
    });
}

function subscribe({ interval, slug }, quantity = null) {
  return axios.post('v2/subscriptions', {
    interval,
    slug,
    quantity,
  })
    .then(({ data }) => {
      fetchUser();
      return data.data;
    });
}

function unsubscribe() {
  return axios.delete('v1/subscriptions');
}

function updateSubscription({ interval, slug }, quantity) {
  return axios.put('v1/subscriptions',
    {
      interval,
      slug,
      quantity,
    });
}

function getInvoices(limit = null) {
  return axios.get('v2/subscriptions/invoices', {
    params: {
      limit,
    },
  });
}

function voidInvoice(invoiceId, subscription) {
  return axios.delete(`v1/subscriptions/${subscription}/invoice/${invoiceId}`);
}

export default {
  getSubscription,
  subscribe,
  unsubscribe,
  updateSubscription,
  getInvoices,
  voidInvoice,
};
